import { metaAI } from "neql"
import { useNeqlContextProvider } from "./useNeqlContextProvider"

export const useAIModelsForApp = (appID: string) => {
    const clientForApp = useNeqlContextProvider("metaAIApp", appID)

    return metaAI.useGetAiModelsForAppQuery({
        client: clientForApp,
        variables: {
            appId: appID,
            offset: 0,
            limit: 50,
            days: 7
        }
    })
}
